import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/home/home.component')
      .then(m => m.HomeComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./components/about/about.component')
      .then(m => m.AboutComponent)
  },
  {
    path: 'products',
    loadComponent: () => import('./components/products/products.component')
      .then(m => m.ProductsComponent)
  },
  {
    path: 'rituals',
    loadComponent: () => import('./components/rituals/rituals.component')
      .then(m => m.RitualsComponent)
  },
  {
    path: 'vedic-evidence',
    loadComponent: () => import('./components/vedic-evidence/vedic-evidence.component')
      .then(m => m.VedicEvidenceComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('./components/contact/contact.component')
      .then(m => m.ContactComponent)
  },
  {
    path: 'faq',
    loadComponent: () => import('./components/faq/faq.component')
      .then(m => m.FaqComponent)
  },
  {
    path: 'disclaimer',
    loadComponent: () => import('./components/disclaimer/disclaimer.component')
      .then(m => m.DisclaimerComponent)
  }
];